export default __webpack_public_path__ + "static/media/section1-bg3.856ddaec.png";